import Vue from 'vue';
import Router from 'vue-router';
import Comparison from '../components/comparison/Comparison';
import LongTermMap from '../components/long-term-map/LongTermMap';

Vue.use(Router);

export default new Router({
  routes: [{
    path: '/',
    name: 'compare-quarters',
    component: Comparison,
    props: true,
  },
  {
    path: '/historical-view/',
    name: 'historical-view',
    component: LongTermMap,
    props: true,
  },
  // dummy routes so we can handle the page jumps.
  {
    path: '/macro',
    name: 'macro',
    component: Comparison,
    props: true,
  },
  {
    path: '/market',
    name: 'market',
    component: Comparison,
    props: true,
  },
  {
    path: '/credit',
    name: 'credit',
    component: Comparison,
    props: true,
  },
  {
    path: '/solvency',
    name: 'solvency',
    component: Comparison,
    props: true,
  },
  {
    path: '/funding',
    name: 'funding',
    component: Comparison,
    props: true,
  },
  {
    path: '/contagion',
    name: 'contagion',
    component: Comparison,
    props: true,
  },
  {
    path: '/categories',
    name: 'categories',
    component: Comparison,
    props: true,
  },
  // default to compare quarters
  {
    path: '*',
    redirect: '/',
  },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js